import React, { useEffect, useState, useRef } from "react";
import HTMLFlipBook from 'react-pageflip';
import "../css/book.css";

const BookReading = () => {
    const bookRef = useRef(null);

    const [totalPages, setTotalPages] = useState(0);
    const [bookId, setBookId] = useState(0);
    const [studentId, setStudentId] = useState(0);
    const [pageNo, setPageNo] = useState(1);
    const params = new URLSearchParams(window.location.search);
    // `https://sms.cooledsys.com/static/media/bg.4f68f158de22978927ad.jpeg`
    // `https://sms.cooledsys.com//book-${bookId}/b2-${pageNo}.jpg`
    const pages = Array.from({ length: totalPages }, (_, index) => {
        const pageNumber = String(index + 1).padStart(4, '0');
        return `https://sms.cooledsys.com//book-${bookId}-pages/book-${bookId}_page-${pageNumber}.jpg`;
    });


    useEffect(() => {
        // console.log("readBook called, params", params);
        setBookId(params.get("bookId") || 0);
        setStudentId(params.get('studentId'));
        setTotalPages(params.get('pages'));
    }, [params])

    const handleFlip = (e) => {
        const currentPage = e.data;
        const visiblePages = [currentPage + 1, currentPage + 2];
        // console.log("Visible pages:", visiblePages[0], "&", visiblePages[1]);
    };

    useEffect(() => {
        const handleResize = () => {
            const bookElement = document.querySelector(".ebook-book");
            if (bookElement && window.innerWidth <= 931) {
                bookElement.classList.remove("ebook-book");
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleFullscreen = () => {
        const elem = bookRef.current;
        if (!elem) return;

        if (!document.fullscreenElement) {
            elem.requestFullscreen().catch(err => {
                console.error(`Error trying to enter fullscreen: ${err.message}`);
            });
        } else {
            document.exitFullscreen();
        }
    };



    return (
        <div className="ebook">
            <div className="ebook-flipbook-wrapper" >
                {/* <h2>Image Flip Book</h2> */}
                <div className="ebook-book" ref={bookRef}>
                    <HTMLFlipBook
                        width={550}
                        height={600}
                        minWidth={315}
                        maxWidth={1000}
                        minHeight={400}
                        maxHeight={1536}
                        size="stretch"
                        showCover={true}
                        usePortrait={false}
                        mobileScrollSupport={true}
                        onFlip={handleFlip}
                    >
                        {pages.map((src, index) => (
                            <div key={index} className="ebook-page">
                                <img
                                    src={src}
                                    alt={`Page ${index + 1}`}
                                    onError={() => console.error(`Image failed to load: ${src}`)}
                                />
                            </div>
                        ))}
                    </HTMLFlipBook>
                </div>
            </div>
            <button onClick={toggleFullscreen} className="ebook-fullscreen-btn">
                Fullscreen
            </button>
        </div>
    );
};

export default BookReading;
